import Client from 'requests/client';

const client = new Client({
  basePath: '/admin_users/sign_in',
  dataType: false,
  headers: {
    'No-Turbo-Redirect': true,
  },
});

export const adminSignInRequest = async data => {
  return client.create({ data });
};
